import { render, staticRenderFns } from "./MaterialOrdersPopup.vue?vue&type=template&id=2e6da6df&scoped=true&lang=pug&"
import script from "./MaterialOrdersPopup.vue?vue&type=script&lang=js&"
export * from "./MaterialOrdersPopup.vue?vue&type=script&lang=js&"
import style0 from "./MaterialOrdersPopup.vue?vue&type=style&index=0&id=2e6da6df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6da6df",
  null
  
)

export default component.exports